var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.608398,
    y: 0.826172,
    width: 40.117,
    height: 40.1742,
    rx: 20.0585,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6903 21.6614V27.2011H25.4522V21.9992C25.4522 20.7156 24.98 19.8373 23.8331 19.8373C22.9561 19.8373 22.4164 20.4453 22.2141 20.9858C22.1466 21.1885 22.0791 21.4587 22.0791 21.7965V27.2011H18.841C18.841 27.2011 18.9085 18.4186 18.841 17.5404H22.0791V18.8915C22.4839 18.216 23.2934 17.2701 24.98 17.2701C27.0713 17.2701 28.6903 18.6889 28.6903 21.6614ZM15.4679 12.8789C14.3886 12.8789 13.6465 13.622 13.6465 14.5678C13.6465 15.5136 14.3211 16.2568 15.4005 16.2568C16.5473 16.2568 17.2219 15.5136 17.2219 14.5678C17.2894 13.5545 16.6148 12.8789 15.4679 12.8789ZM13.8489 27.2011H17.087V17.5404H13.8489V27.2011Z",
    fill: "#2878B7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9c9b20ca6c1251b3857ba3c1e2f5d32d.svg";
export { ForwardRef as ReactComponent };